import { render } from "./Avatar.vue?vue&type=template&id=6231e284&scoped=true"
import script from "./Avatar.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Avatar.vue?vue&type=script&charset=utf-8&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=6231e284&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6231e284"]])

export default __exports__